export default "__VITE_ASSET__DvF3$PfL__"